import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

import { NgAppListHeaderComponent } from "./ng-app-list-header.component";
import { NgAppListHeaderService } from "./ng-app-list-header.service";
import { NgSharedModule } from "../../ng-shared/ng-shared.module";

import { NgAppListStateSummaryComponent } from "./ng-app-list-state-summary/ng-app-list-state-summary.component";
import { NgAppListTenantSummaryComponent } from "./ng-app-list-tenant-summary/ng-app-list-tenant-summary.component";
import { NgAppListTopExecComponent } from "./ng-app-list-top-exec/ng-app-list-top-exec.component";
import { NgAppFeatureToggleService } from "../../ng-shared/ng-services/ng-app-feature-toggle.service";
import { NgAppChangeNotificationService } from "../../ng-shared/ng-services/ng-app-change-notification.service";

@NgModule({
    imports: [
        NgSharedModule,
        CommonModule,
        RouterModule,
        BrowserModule
    ],
    declarations: [
        NgAppListHeaderComponent,
        NgAppListStateSummaryComponent,
        NgAppListTenantSummaryComponent,
        NgAppListTopExecComponent,
    ],
    exports: [
        NgAppListHeaderComponent,
        NgAppListStateSummaryComponent,
        NgAppListTenantSummaryComponent,
        NgAppListTopExecComponent,
    ],
    providers: [
        NgAppListHeaderService,
        NgAppFeatureToggleService,
        NgAppChangeNotificationService
    ]
})
export class NgAppListHeaderModule {
    constructor() {
    }
}
